import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  ICancellationReport,
  IClientIncomeReport,
  IDeliveryPickupReport,
  IDiscountUsageReport,
  IExportDataReport,
  IFeatureUtilizationReport,
  IFinancialOrderReport,
  IForemanTaskReport,
  IGeographicRevenueReport,
  IInventoryUsageReport,
  IJobCostingReport,
  IMarketingRevenueReport,
  IOrderRevenueReportResult,
  IOverbookedItemReport,
  IQueryParamListExport,
  IQuoteRevenueReportResult,
  IRevenueMonthReport,
  IRevenueWeekReport,
  ISubRentalsReport,
  ITaskCompletionReport,
  ITransactionSummaryReport,
} from '~/utils/interface/reports';
import axiosClient from './axiosClient';
import { urlApiReports } from '~/utils/constants/apis';

const reportsApi = {
  getListOverbookingItemReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListOverbookingItemReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IOverbookedItemReport[]>>>(url, { params });
  },

  getListSubRentalsReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListSubRentalsReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<ISubRentalsReport[]>>>(url, { params });
  },

  getListClientIncomeReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListClientIncomeReport;
    return axiosClient.get<IBaseResponse<IClientIncomeReport[]>>(url, { params });
  },

  getListRevenueReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListRevenueReport;
    return axiosClient.get<IBaseResponse<IRevenueWeekReport[] | IRevenueMonthReport[]>>(url, { params });
  },

  getListGeographyRevenueReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListGeographyRevenueReport;
    return axiosClient.get<IBaseResponse<IGeographicRevenueReport[]>>(url, { params });
  },

  getListQuoteRevenueReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListQuoteRevenueReport;
    return axiosClient.get<IBaseResponse<IQuoteRevenueReportResult>>(url, { params });
  },

  getListOrderRevenueReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListOrderRevenueReport;
    return axiosClient.get<IBaseResponse<IOrderRevenueReportResult>>(url, { params });
  },

  getListCancellationReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListCancellationReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<ICancellationReport[]>>>(url, { params });
  },

  getListDeliveryPickupReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListDeliveryPickupReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IDeliveryPickupReport[]>>>(url, { params });
  },

  getListTaskCompletionReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListTaskCompletionReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<ITaskCompletionReport[]>>>(url, { params });
  },

  getDiscountUsageReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListDiscountUsageReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IDiscountUsageReport[]>>>(url, { params });
  },

  getListFeatureUtilizationReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListFeatureUtilizationReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IFeatureUtilizationReport[]>>>(url, { params });
  },

  getListJobCostingReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListJobCostingReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IJobCostingReport[]>>>(url, { params });
  },

  getListInventoryUsageReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListInventoryUsageReport;
    return axiosClient.get<IBaseResponse<IInventoryUsageReport[]>>(url, { params });
  },

  getListForemanTaskCompletionReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListForemanTaskCompletionReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IForemanTaskReport[]>>>(url, { params });
  },

  getListMarketingRevenueReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListMarketingRevenueReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IMarketingRevenueReport[]>>>(url, { params });
  },

  getListFinancialOrderReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListFinancialOrderReport;
    return axiosClient.get<IBaseResponse<IListDataResponse<IFinancialOrderReport[]>>>(url, { params });
  },

  getListTransactionSummaryReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.getListTransactionSummaryReport;
    return axiosClient.get<IBaseResponse<ITransactionSummaryReport[]>>(url, { params });
  },

  exportDataReport: (params: IQueryParamListExport) => {
    const url = urlApiReports.exportDataReport;
    return axiosClient.get<IBaseResponse<IExportDataReport>>(url, { params });
  },
};

export default reportsApi;
